import { render, staticRenderFns } from "./NavigationComponent.vue?vue&type=template&id=a4c29ed4&scoped=true"
import script from "./NavigationComponent.vue?vue&type=script&lang=js"
export * from "./NavigationComponent.vue?vue&type=script&lang=js"
import style0 from "./NavigationComponent.vue?vue&type=style&index=0&id=a4c29ed4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4c29ed4",
  null
  
)

export default component.exports